<script>
    import { getContext } from "svelte";
    import { Display, key as dimensionsDisplayKey } from "../context/dimensionsDisplay.js";

    /*                                                    */
    let { variation } = $props();

    const getDimensionsDisplay = getContext(dimensionsDisplayKey) ?? null;
    const topInfoAsDimensionDisplayMode = (getDimensionsDisplay && getDimensionsDisplay()?.displayMode) ?? Display.KEEP_EXISTING;

    const showMultipleSizes = (currentVariation) => {
        return currentVariation.size && currentVariation.size !== "";
    };
</script>

{#if topInfoAsDimensionDisplayMode === Display.SKIP}
    <!-- left blank -->
{:else if topInfoAsDimensionDisplayMode === Display.KEEP_EXISTING && variation.topInfo}
    <div class="reco_cinema__top-info oc-copy-100">
        <strong>{variation.topInfo}</strong>
    </div>
{:else if topInfoAsDimensionDisplayMode === Display.CALCULATE}
    <div class="reco_cinema__top-info-dimensions oc-copy-75 oc-text-color-secondary oc-my-50">
        {showMultipleSizes(variation) ? "Mehrere Größen" : variation.topInfo}
    </div>
{/if}

<style lang="scss">
    .reco_cinema__top-info {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .reco_cinema__top-info-dimensions {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /*                           */
        -webkit-box-orient: vertical;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        white-space: normal;
    }
</style>
